export const parseGroupIds = (s: string): string[] => {
    return s.split(",").map((g) => g.trim()).filter(Boolean);
};